import { useCapitalGlobalProposalStep2Form } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step2-form.context';
import { Button } from '@noorden-insurtech/alba-design-system';
import { ArrowLeft, FileCheck } from 'lucide-react';

export function CapitalGlobalProposalStepPagamentoFooter() {
  const {
    isViewMode,
    canGoBack,
    onBack,
    handleSubmit,
    isSubmitting,
    isPaymentTypesReady,
    isLoadingPaymentTypes,
  } = useCapitalGlobalProposalStep2Form();

  return (
    <div className='flex flex-row justify-between items-center gap-6 self-stretch'>
      <Button
        type='button'
        variant='ghost'
        size='lg'
        className='flex items-center gap-2'
        onClick={onBack}
        disabled={isViewMode || !canGoBack || isSubmitting}
      >
        <ArrowLeft className='h-5 w-5' strokeWidth={1.6} />
        Voltar
      </Button>
      <Button
        type='button'
        variant='primary'
        size='md'
        className='flex items-center gap-2 px-8 py-2 rounded-xl'
        onClick={() => void handleSubmit()}
        disabled={
          isViewMode ||
          isSubmitting ||
          isLoadingPaymentTypes ||
          !isPaymentTypesReady
        }
        loading={isSubmitting || isLoadingPaymentTypes}
      >
        Gerar Proposta
        <FileCheck className='h-6 w-6' strokeWidth={2} />
      </Button>
    </div>
  );
}
